"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var useRandomGame = function () {
    var games = (0, swr_hooks_1.useGamesByCategories)().data;
    return (0, react_1.useMemo)(function () {
        var _a;
        if (!games)
            return null;
        var categories = Object.keys(games);
        var filteredCategories = categories.filter(function (category) {
            var _a, _b, _c;
            if ((_a = games === null || games === void 0 ? void 0 : games[category]) === null || _a === void 0 ? void 0 : _a.previewGames)
                return (category &&
                    ((_b = games === null || games === void 0 ? void 0 : games[category]) === null || _b === void 0 ? void 0 : _b.previewGames) &&
                    (((_c = games[category].previewGames) === null || _c === void 0 ? void 0 : _c.length) || 0) > 0);
        });
        var randomCategory = filteredCategories[Math.floor(Math.random() * filteredCategories.length)];
        var randomGames = ((_a = games === null || games === void 0 ? void 0 : games[randomCategory]) === null || _a === void 0 ? void 0 : _a.previewGames) || [];
        return randomGames[Math.floor(Math.random() * randomGames.length)];
    }, [games]);
};
exports.default = useRandomGame;
